import * as React from 'react';
import { Flex } from 'rebass';
import Card from '../Card';
import Icon from '../Icon';
import Input from '../Input';
function SearchBar(_a) {
    var buttons = _a.buttons, count = _a.count, filterTablets = _a.filterTablets, query = _a.query, label = _a.label, onChange = _a.onChange, onFocus = _a.onFocus, onBlur = _a.onBlur, onReturn = _a.onReturn, children = _a.children;
    var placeholder = React.useMemo(function () { return label(count); }, [label, count]);
    var onQueryChanged = React.useCallback(function (event) { return onChange(event.target.value); }, [onChange]);
    var onFocused = React.useCallback(function () { return onFocus === null || onFocus === void 0 ? void 0 : onFocus(); }, [onFocus]);
    var onBlurred = React.useCallback(function () { return onBlur === null || onBlur === void 0 ? void 0 : onBlur(); }, [onBlur]);
    var onReturnPressed = React.useCallback(function (value) { return onReturn === null || onReturn === void 0 ? void 0 : onReturn(value); }, [onReturn]);
    return (React.createElement(Flex, { alignItems: "center", justifyContent: "space-between", sx: {
            width: '100%',
            height: '56px',
            borderTopLeftRadius: 'large',
            borderTopRightRadius: 'large',
            borderStyle: 'solid',
            borderWidth: '1px',
            borderColor: 'transparent',
            borderBottomColor: 'neutral_2',
            backgroundColor: 'neutral_0',
            overflow: 'hidden',
            '&:focus-within': {
                borderColor: 'primary_2',
            },
        } },
        filterTablets,
        React.createElement(Flex, { alignItems: "center", justifyContent: "space-between", width: "100%", height: "100%", sx: {
                paddingLeft: '24px',
            } },
            React.createElement(Icon, { icon: "search", color: "neutral_6" }),
            !children && (React.createElement(Input, { fullWidth: true, fullHeight: true, variant: "search", placeholder: placeholder, width: "100%", value: query, onChange: onQueryChanged, onFocus: onFocused, onBlur: onBlurred, onReturn: onReturnPressed })),
            children),
        buttons &&
            buttons.map(function (b, i) { return (React.createElement(Card, { p: 0, key: i, sx: {
                    borderColor: 'neutral_4',
                    borderLeftStyle: 'solid',
                    borderLeftWidth: '1px',
                    minWidth: 'auto',
                } }, b)); })));
}
export default React.memo(SearchBar);
